// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL:"https://achotelairportparking.com/api/public",
  //API_URL:"http://localhost:8000",
  payment: {
      paypal: {
      clientId: 'AZaUi4SH-gwHLSbAkNrQ_biawcGGPpIXHUVWy8RLT-kS56eYKKvnacVCLpVMy5WHgNJhjc4Gmc_BCF9S'
      },
      stripe:"pk_test_51IO45IEsATRxZP7ZltFxtZQ5mfUdOGodV0dEQUSFHFpKJnbA4UBBzJCMs5vIR8FFBhbP6I0gGajSs8ukqQjNtxBs000vzBY0w5"

    },
    promotion_url:"http://localhost:4200/qr-code-check"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
